// ============================================================================
// ORDERS · Collection — how the world stays current (CLB-010)
// ============================================================================
// The cards are built in SQL from the Book, the developments and the 2027
// decisions. Three ways a change reaches an open Collection:
//   1. a Realtime event on `developments` or `selection_decisions` (both in the
//      supabase_realtime publication). A Book import reaches here too: the
//      deferred trigger on orders_lines runs sync_dev_procurement, which writes
//      the developments it moves. Events are COALESCED: the first one schedules
//      one refresh LIVE_COALESCE_MS later and the rest of the burst joins it, so
//      an import of hundreds of rows refetches once, not hundreds of times (a
//      trailing debounce could keep resetting through a long import and never
//      fire). Tier B (Conv #54): the builders are heavy.
//   2. a poll every LIVE_POLL_MS while the tab is visible — for what sends no
//      event: an order line edited in the Book (orders_lines is NOT in the
//      publication), a development-less CL row, another person's override.
//   3. refetch on window focus (useCollectionCards / useCollectionRepeats).
// ============================================================================

export const LIVE_COALESCE_MS = 10 * 1000;
export const LIVE_POLL_MS = 90 * 1000;
export const LIVE_TABLES = ['developments', 'selection_decisions'];

// Wrapped on purpose: a bare `{ set: setTimeout }` makes `timers.set(...)` run with
// `this` = the object, and browsers throw "Illegal invocation" (Sentry JAVASCRIPT-REACT-1J).
const DEFAULT_TIMERS = { set: (f, ms) => setTimeout(f, ms), clear: (t) => clearTimeout(t) };

/** One run of `fn` per window: the first poke schedules it, the rest join. */
export function createCoalescer(fn, ms = LIVE_COALESCE_MS, timers = DEFAULT_TIMERS) {
  let t = null;
  return {
    poke() {
      if (t) return false;
      t = timers.set(() => { t = null; fn(); }, ms);
      return true;
    },
    cancel() { if (t) { timers.clear(t); t = null; } },
    pending: () => t !== null,
  };
}
